
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.458 4.318L5.542 6.836m0 2.328l3.916 2.518M5.885 8a2.154 2.154 0 11-4.308 0 2.154 2.154 0 014.308 0zm7.538 4.846a2.154 2.154 0 11-4.308 0 2.154 2.154 0 014.308 0zm0-9.692a2.154 2.154 0 11-4.308 0 2.154 2.154 0 014.308 0z","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    